require('paginationjs');

const itemsPerPage = 24;
const paginationClass = 'paginationjs-theme-blue paginationjs-big w-100';

$('#images-pagination').pagination({
    dataSource: $(' #datasource .images ').toArray(),
    pageSize: itemsPerPage,
    className: paginationClass,
    showPageNumbers: false,
    showNavigator: false,
    callback: function (data) {
        var html = template(data);
        $('#references-filter').html(html).hide().fadeIn();
    }
});

function template(data) {
    let html = '';
    $.each( data, function( key, value ) {
        html += value.outerHTML;
    });
    return html;
}

$(' #filters-id a ').click(function () {
    if ($(this).attr('data-filter')) {
        let array = $(' #datasource .images').filter('[data-filter="' + $(this).attr('data-filter') + '"]');
        console.log(array);
        $('#images-pagination').pagination({
            dataSource: array.toArray(),
            pageSize: itemsPerPage,
            className: paginationClass,
            showPageNumbers: false,
            showNavigator: false,
            callback: function (data) {
                var html = template(data);
                // console.log(data);
                $('#references-filter').html(html).hide().fadeIn();
            }
        });
    } else {
        $('img').fadeIn();
        $('#images-pagination').pagination({
            dataSource: $(' #datasource .images ').toArray(),
            pageSize: itemsPerPage,
            className: paginationClass,
            showPageNumbers: false,
            showNavigator: false,
            callback: function (data) {
                var html = template(data);
                $('#references-filter').html(html).hide().fadeIn();
            }
        });
    }
    return false;
});

